import { PageLayout } from '../../PageLayout';
import { HexEmbed } from './HexEmbed';

export const HexAnalyticsPage = () => {
  return (
    <PageLayout
      pageTitle="Analytics"
      className="flex flex-col overflow-hidden">
      <HexEmbed />
    </PageLayout>
  );
};
